//TODO:  на проде другой адресс
import {InvestVariation} from "@/common/types/commonTypes.ts"

export const TOKEN_ZNX_MINT_ADDRESS = 'ZenexEqqyiYCjykxYZr2cW6g3xVwQ5RggHmo245q5J5' // set from .env.production
export const TOKEN_USDC_MINT_ADDRESS = 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v'

// console.debug('env', import.meta.env)
// Turn on live mode for real transactions & disable demos inside the app
export const IS_REAL_PLAY = true

export const ReferralLevels = ['STARTER', 'BRONZE', 'SILVER', 'GOLD', 'DIAMOND'] as const

export const TariffRanges = {
  Basic: {min: 50, max: 4999},
  Advanced: {min: 5000, max: 9999},
  Premium: {min: 10000, max: Infinity},
}

// How many days of price history to fetch
export const DAYS_HEADER_ZENEX_CHART = 1

// -> Set this const to 'first page' to see 'promo variation' of Invest <-
export const INVEST_FIRST_PAGE:InvestVariation = 'third page'

// New referral
export const REFERRAL_DETAILS_BLOCKS_DISABLED = false // this disables 'paid out in 2025' & 'members' from referral
export const LEARN_MORE_DISABLED = false // disables button at Referral program
export const INVITER_NICK_DISABLED = false